import React from 'react';
import { Box } from '@cko/primitives';
import styled from 'styled-components';
import { useLayout } from '../../../context/Layout';
const Container = styled(Box) `
  height: 100%;
`;
const Content = styled(Box) `
  padding: ${({ $isFullPage }) => $isFullPage ? 'var(--layout-sandgrain)' : 'var(--layout-saxophone)'};
`;
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const NewLayout = ({ children, navigation }) => {
    const { isFullPage, isCustomTablePage } = useLayout();
    return (React.createElement(Container, null,
        React.createElement(Box, null,
            !isFullPage && navigation,
            React.createElement(Content, { "$isFullPage": isFullPage, "$isCustomTablePage": isCustomTablePage, "data-testid": "app-body" }, children))));
};
